<script setup lang="ts">
import { faCircleNotch } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from './FontAwesomeIcon.vue';
</script>

<template>
  <FontAwesomeIcon :icon="faCircleNotch" spin />
</template>
